import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "services/axios";

  /* -------------------------------------- Get Menu Engineering Report List ------------------------------- */
  export const getMenuEngineeringReportList = createAsyncThunk("menuEngineeringReport/getMenuEngineeringReportList",  
    async (args, thunkApi) => {
    try {
      const { data } = await axios.get(`https://rostoapi.smartgate-egypt.com/Reports/GetMenuEngineeringList`);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response.data);
    }
  }
);


 /* --------------------------------------- Menu Engineering Filter Data ------------------------------*/
 export const getMenuEngineeringFilteredData = createAsyncThunk("menuEngineeringReport/getMenuEngineeringFilteredData ", 
  async (args, thunkApi) => {
  try {
    return (args);
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);
export const resetMenuEngineeringFilteredData = createAsyncThunk( "menuEngineeringReport/resetMenuEngineeringFilteredData ", 
  async (args, thunkApi) => { 
  try {
    return args;
  } catch (e) {
    return thunkApi.rejectWithValue(e.response.data);
  }
}
);